/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Show_Identified_Vehicles_Panel_DescriptionInputs */

const fr_settings_show_identified_vehicles_panel_description = /** @type {(inputs: Settings_Show_Identified_Vehicles_Panel_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lors du filtre par ligne sur la carte, affiche le tableau des véhicules identifiés circulant sur la ligne.`)
};

const en_settings_show_identified_vehicles_panel_description = /** @type {(inputs: Settings_Show_Identified_Vehicles_Panel_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When filtering the map by line, show the table of identified vehicles running on the line.`)
};

/**
* | output |
* | --- |
* | "When filtering the map by line, show the table of identified vehicles running on the line." |
*
* @param {Settings_Show_Identified_Vehicles_Panel_DescriptionInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_show_identified_vehicles_panel_description = /** @type {((inputs?: Settings_Show_Identified_Vehicles_Panel_DescriptionInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Show_Identified_Vehicles_Panel_DescriptionInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_settings_show_identified_vehicles_panel_description(inputs)
	return en_settings_show_identified_vehicles_panel_description(inputs)
});